// Returns reactive variable tracking system switch between light and dark mode.

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import {ref} from "vue";
import {tryOnMounted} from "@vueuse/core";

const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
const displayMode = ref("");

function changeDisplayModeClass(newClass) {
  if (!newClass) return displayMode.value;
  if (displayMode.value === newClass) return displayMode.value;
  if (displayMode.value) document.body.classList.remove(displayMode.value);
  document.body.classList.add(newClass);
  return newClass;
}

function getMediaPreference() {
  // currently, only enable dark mode on localhost
  // if (location.host.match(/^vizbi/i)) return "lightMode";
  // next line runs the query https://stackoverflow.com/q/58626873
  return mediaQuery.matches
    ? changeDisplayModeClass("darkMode")
    : changeDisplayModeClass("lightMode");
}

// Initialise synchronously so the correct mode is known before first render.
// document.body is available at module-import time in a browser SPA.
displayMode.value = getMediaPreference();

export function useDisplayMode() {
  tryOnMounted(() => {
    // Already initialised above; just register the runtime change listener.
    mediaQuery.addEventListener("change", () => {
      displayMode.value = getMediaPreference();
      log(`displayMode is now ${displayMode.value}`);
    });
  });
  return displayMode;
}
